import Vue from 'vue';
import i18n from '@/translations';

export default Vue.component('v-anal', {
	name: 'Analytics',

	render: (h) => h(),

	computed: {
		activeModal(): string {
			return this.$store.state.activeModal;
		},

		appModalName(): string {
			return i18n.t('routes.getApp.modalName') as string;
		}
	},

	created() {
		if (typeof window === 'undefined') {
			return;
		}

		if (typeof dataLayer === 'undefined') {
			window.dataLayer = [];
		}

		this.$root.$on('trackToGTM', (data: []) => this.pushGaEvent(...data));

	},

	watch: {
		activeModal: {
			handler(modal: string) {
				if (typeof window === 'undefined') {
					return;
				}

				if (modal === this.appModalName) {
					this.pushGaEvent('cardInterest', this.$route.params.card);
				}

			}
		}
	},

	methods: {
		// trekovani custom UserInteration eventu
		pushGaEvent(eventCategory?: string, eventAction?: string, eventLabel?: string, eventValue?: any) {

			dataLayer!.push({
				event: 'UserInteraction',
				eventCategory,
				eventAction,
				eventLabel,
				eventValue
			});

			console.log(
				'UserInteraction',
				eventCategory,
				eventAction,
				eventLabel,
				eventValue
			)

		}
	}
});

